/* eslint-disable */
import { Box, FormControl, MenuItem, Select, useTheme } from "@mui/material";
import { useState } from "react";
import GaugeChart from "react-gauge-chart";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function ScoreGraph({ scoreValue }) {
  const theme = useTheme();
  const [age, setAge] = useState(10);
  const handleChange = event => {
    setAge(event.target.value);
  };
  // const score = scoreValue || 0;
  // const percent = score / 100;
  // const arcsLength = [0.2, 0.2, 0.2, 0.2, 0.2];
  // let colorRanges = [];

  // if (percent <= 0.1) {
  //   colorRanges = ["#F14623", "#D9D9D9", "#D9D9D9", "#D9D9D9", "#D9D9D9"];
  // } else if (percent <= 0.2) {
  //   colorRanges = ["#F14623", "#F79025", "#D9D9D9", "#D9D9D9", "#D9D9D9"];
  // } else if (percent <= 0.3) {
  //   colorRanges = ["#F14623", "#F79025", "#FFCE10", "#D9D9D9", "#D9D9D9"];
  // } else if (percent <= 0.4) {
  //   colorRanges = ["#F14623", "#F79025", "#FFCE10", "#5CBB76", "#D9D9D9"];
  // } else if (percent <= 0.5) {
  //   colorRanges = ["#F14623", "#F79025", "#FFCE10", "#5CBB76", "#A1D9A1"];
  // } else if (percent <= 0.6) {
  //   colorRanges = ["#F79025", "#FFCE10", "#5CBB76", "#A1D9A1", "#D9D9D9"];
  // } else if (percent <= 0.7) {
  //   colorRanges = ["#FFCE10", "#5CBB76", "#A1D9A1", "#3DAE5B", "#D9D9D9"];
  // } else if (percent <= 0.8) {
  //   colorRanges = ["#5CBB76", "#A1D9A1", "#3DAE5B", "#2C8E4E", "#D9D9D9"];
  // } else if (percent <= 0.9) {
  //   colorRanges = ["#A1D9A1", "#3DAE5B", "#2C8E4E", "#1E6F3E", "#D9D9D9"];
  // } else {
  //   colorRanges = ["#3DAE5B", "#2C8E4E", "#1E6F3E", "#145428", "#69d194ff"];
  // }

  const score = scoreValue || 0;
  const percent = score / 100;

  // 20 small arcs → each = 5%
  const arcsLength = Array(20).fill(1 / 20);

  // colors for each 20% block (4 small arcs each)
  const sectionColors = [
    "#F14623", // 0–20
    "#F79025", // 20–40
    "#FFCE10", // 40–60
    "#5CBB76", // 60–80
    "#3DAE5B", // 80–100
  ];

  const colorRanges = arcsLength.map((_, index) => {
    const arcPercentEnd = ((index + 1) / 20) * 100;

    if (arcPercentEnd <= score) {
      return sectionColors[Math.floor(index / 4)];
    }

    return "#D9D9D9";
  });


  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "300px",
        "@media screen and (min-width:1200px) and (max-width:1380px)": {
          maxWidth: "200px",
        },
        "@media screen and (min-width:900px) and (max-width:1100px)": {
          maxWidth: "150px",
        },
        "& > svg": { height: "120px" },
      }}
    >
      <GaugeChart
        id="score-gauge"
        nrOfLevels={20}
        arcsLength={arcsLength}
        colors={colorRanges}
        percent={percent}
        needleColor="transparent"
        needleBaseColor="transparent"
        textColor="transparent"
        animate={true}
        arcPadding={0.02}
        arcWidth={0.3}
      />
      <Box
        sx={{
          textAlign: "center",
          marginTop: "-40px",
          fontSize: "32px",
          fontWeight: "bold",
          lineHeight: "1",
          "@media screen and (min-width:1200px) and (max-width:1380px)": {
            fontSize: "26px",
            marginTop: "-35px",
          },
          "@media screen and (min-width:900px) and (max-width:1100px)": {
            fontSize: "22px",
            marginTop: "-28px",
          },
        }}
      >
        {score}
      </Box>
      <FormControl
        fullWidth
        sx={{
          "& .MuiInputBase-root": {
            justifyContent: "center",
            "& .MuiSelect-select": {
              width: "auto",
              padding: "0px",
              fontSize: "14px",
              fontWeight: 700,
            },
            "& .MuiSelect-icon": {
              position: "relative",
              right: "auto",
              fontSize: "20px",
              color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
              marginLeft: "4px",
              pointerEvents: "auto",
            },
            "& fieldset": { display: "none" },
          },
        }}
      >
        <Select id="demo-simple-select" value={age} onChange={handleChange} IconComponent={ExpandMoreIcon}>
          <MenuItem value={10}>Select competitors</MenuItem>
          <MenuItem value={20}>TOP 10</MenuItem>
          <MenuItem value={30}>TOP 30</MenuItem>
          <MenuItem value={40}>Custom selection</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default ScoreGraph;
